<template>
    <!-- 军事/公安类升学(民航招飞，海军招飞，空军招飞，军校招生，公安院校，航海类院校) -->
    <!-- 航海类院校 -->
    <div class="nautical_category_school">
        <h5>航海类专业招生</h5>
        <div class="content">
            <p>在提前批次的填报中，除了考生和家长比较关注的军校生、国防生、免费师范生等类别，航海类专业也是其中之一。</p>
            <p>航海类专业主要包括航海技术、轮机工程和船舶电子电气工程三个专业。航海类专业主要设置于海事类院校。</p>
            <p>航海类专业与普通本科专业在报考方面有一些特殊要求，主要体现在：对身体条件要求极高，不适宜女生报考，只招少量女生。航海类专业并不适合所有学生报考，还请有意向报考的考生根据专业的工作性质，分析自身情况，合理选择。</p>
            <p>航海类专业的报考大部分设置于本科提前批次填报，具体分数线可参考往年录取情况。其中武汉理工大学在其招生章程中说明：由于对报考这两个专业的考生身体条件要求较高，若合格生源不足，经有关省（区、市）招办批准可放宽至本科第一批录取控制分数线下20分（不低于本科第二批录取控制分数线）择优录取。</p>
            <p>目前国内开设航海类专业的高校较之过去开始增多，但是只有具有优势专业的大连海事大学、上海海事大学、集美大学和武汉理工大学等几所专业发展历史悠久、积淀深厚的高校其就业情况良好。</p>
            <div class="main">
                <p class="title">报考要求：</p>
                <p class="detail">根据《海船船员健康检查要求》，航海类专业要求无色盲（弱）、无复视，其中航海技术专业要求身高1.65米及以上。远视力：双眼裸视力均能达0.5及以上，且矫正视力均能达0.8及以上。近视力：双眼裸视力均能达0.8及以上；或者双眼裸视力均能达0.4及以上，且双眼矫正视力均能达1.0及以上。轮机工程（海上方向）专业、船舶电子电气工程专业要求身高1.60米及以上。远视力：双眼裸视力均能达0.4及以上，且矫正视力均能达0.6及以上。近视力：双眼裸视力均能达0.8及以上；或者双眼裸视力均能达0.4及以上，且双眼矫正视力均能达1.0及以上。其他要求参照《海船船员健康检查要求》。</p>
            </div>
            <div class="main">
                <p class="title">就业情况：</p>
                <p class="detail">航海类专业属于特种专业，毕业生就业的途径相对于法学、文秘、计算机等其他专业的毕业生要少。就目前而言，航海类专业的就业选择有以下几种：第一，80%的毕业生会选择上船，参与一线的海上驾驶工作。从水手干起，然后到驾驶员，走三副、二副、大副、三管轮、二管轮、大管轮，到船长、轮机长的必经过程。但是，海上工作条件艰苦，孤独寂寞，要成功成为一名出色船长，往往比在陆上成为一名科长、处长要艰辛得多。某些航海毕业生刚刚上船的时候踌躇满志、斗志昂扬，但是经历几年海上的颠簸，加上文化知识的丢失，与岸上生活的脱节之后，大多经不起考验，毅然放弃海上事业和对航海理想的追求，宁愿重新起步，回归陆上工作。</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // components: { Yuanxiaoku },
    // props: [ 'message' ],
    data() {
        return {
        }
    },
    methods: {
    },
    created() {
    }
}
</script>
<style type="text/css" lang='less' scoped>
    .nautical_category_school {
        // height: 800px;
        padding: 0 20px;
        background-color: #fff;
        h5 {
            line-height: 70px;
            font-size: 24px;
            color: #333;
            text-align: center;
            font-weight: 600;
            border-bottom: 1px solid #dedede;
        }
        .content {
            padding: 20px 0px;
            p {
                line-height: 24px;
                margin-bottom: 10px;
            }
            .main {
                padding-top: 5px;
                .title {
                    color: #2c8ffc;
                }
                .detail {
                    padding-left: 2em;
                }
            }
        }
    }
</style>